import { Box } from '@mantine/core';
import { useFlags } from 'src/feature-flags/FlagsHook';
import CashflowContentDeprecated from './CashflowContentDeprecated';
import { CashflowModelsSection } from './modelling/CashflowModelsSection';
import { ClientCashflowsRedesign } from './redesign/ClientCashflowsRedesign';

export default function CashflowContent() {
  const { flagEnabledFamilyCashflowsRevamp, flagEnabledCashflowModelling } = useFlags();

  if (flagEnabledFamilyCashflowsRevamp) {
    // A divider like the tab's other sections, so it takes their spacing rather than its own.
    return (
      <ClientCashflowsRedesign
        modelsSection={flagEnabledCashflowModelling ? <CashflowModelsSection /> : null}
      />
    );
  }

  return (
    <>
      <CashflowContentDeprecated />
      {flagEnabledCashflowModelling && (
        <Box mt="xl" pb="xl">
          <CashflowModelsSection />
        </Box>
      )}
    </>
  );
}
